import { render, staticRenderFns } from "./policyCornerInfo.vue?vue&type=template&id=1e083d4a&scoped=true"
import script from "./policyCornerInfo.vue?vue&type=script&lang=js"
export * from "./policyCornerInfo.vue?vue&type=script&lang=js"
import style0 from "./policyCornerInfo.vue?vue&type=style&index=0&id=1e083d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e083d4a",
  null
  
)

export default component.exports